import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../BaseComponent';
import { SceneStore } from '../../stores/SceneStore';
import { ProjectSettingsStore } from '../../stores/ProjectSettingsStore';
import { DialogActions } from '../../actions/DialogActions';
import { UIHelper } from '../../utils/UIHelper';
import { SaveType } from '../../constants/Enums';
import { DownloadHelper } from '../../utils/DownloadHelper';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';
import { SceneActions } from '../../actions/SceneActions';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { LongButton } from '../LongButton';
import { ArticleActions } from '../../actions/ArticleActions';

interface BrowserProjectButtonsState {
    downloadPossible: boolean;
}

export class BrowserProjectButtons extends BaseComponent<{}, BrowserProjectButtonsState> {
    protected openInputElement: HTMLInputElement;
    protected importInputElement: HTMLInputElement;

    public componentWillMount(): void {
        this.addStoreListener(SceneStore, this.onChange);
        this.addStoreListener(ProjectSettingsStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element {
        if (AppConfigurationStore.getState().fileBasedProjects) {
            return (
                <div className="long-button-group popup-buttons">
                    <LongButton icon="new-button" onClick={this.newProject}>{t('New')}</LongButton>
                    <LongButton icon="open-button" onClick={this.openProjectFileDialog}>
                        <input
                            type="file"
                            accept=".obk, .pbox, .pec"
                            onChange={this.openProject}
                            className="open-input-element"
                            style={{display: 'none'}}
                            ref={this.setOpenElement}
                        />
                        <span>{t('Open')}</span>
                    </LongButton>
                    <LongButton icon="insert-button" onClick={this.openImportTypicalDialog}>
                        <input
                            type="file"
                            accept=".pec"
                            onChange={this.onInputChange}
                            className="open-input-element"
                            style={{display: 'none'}}
                            ref={this.setImportElement}
                        />
                        <span>{t('Import')}</span>
                    </LongButton>
                    <LongButton
                        icon="save-button"
                        disabled={!this.state.downloadPossible}
                        onClick={DownloadHelper.downloadProjectContainer}
                    >
                        <span>{t('Save as')}</span>
                    </LongButton>
                </div>
            );
        }
        return (
            <div className="long-button-group popup-buttons">
                <LongButton
                    icon="new-button"
                    onClick={this.newProject}
                >
                    {t('New')}
                </LongButton>
            </div>
        );
    }

    protected onInputChange = (): void => {
        ArticleActions.importTypical(this.importInputElement);
    };

    protected setOpenElement = (node: HTMLInputElement): void => {
        this.openInputElement =  node;
    };

    protected setImportElement = (node: HTMLInputElement) => {
        this.importInputElement = node;
    };

    protected onChange = (): void => {
        this.setState({
            downloadPossible: SceneStore.getState().elementCount > 0 || ProjectSettingsStore.getState().floorPlan != null
        });
    };

    protected openProjectFileDialog = (): void => {
        if (this.openInputElement) {
            this.openInputElement.click();
        }
    };

    protected openImportTypicalDialog = (): void => {
        if (this.importInputElement) {
            this.importInputElement.click();
        }
    };

    protected openProject = (): void => {
        DialogActions.openProjectFromFileInput(this.openInputElement);
    };

    protected newProject: () => void = () => {
        UIHelper.ignoreReject(DialogActions.newProject(!this.state.downloadPossible).then(
            async (result: SaveType) => {
                if (result === SaveType.DEVICE) {
                    await DownloadHelper.downloadProjectContainer();
                }
                ViewSettingsActions.closeMessage();
                ViewSettingsActions.changeHamburger(null);
                SceneActions.newScene(null, SaveType.NOT);
            }
        ));
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/BrowserProjectButtons.tsx